import styled from '@emotion/styled';
import { css } from 'emotion';
import { SM_SCREEN_MAX } from '../../modules/Styleguide';
import { Section } from '../../screens/WordpressScreen/components/Hero/styles';

const Header2 = styled.h2`
  color: #5000b9;
  margin: 0 auto;
  margin-bottom: 42px;
  font-size: 3.6rem;
  font-weight: 800;
  @media (max-width: ${SM_SCREEN_MAX}px) {
    display: none;
  }
`;

const SwitchToAnchorOverrideCSS = css`
  padding: 56px 0 170px 0 !important;
  @media (max-width: ${SM_SCREEN_MAX}px) {
    padding: 24px 0 120px 0 !important;
  }
`;

const WordPressSectionHero = styled(Section)`
  height: 300px;
  background-position-y: -30px;
  @media (max-width: 768px) {
    height: 240px;
  }
`;

export { WordPressSectionHero, SwitchToAnchorOverrideCSS, Header2 };
